<template>
    <div class="routing-addresses-list">
        <RoutingAddressCard
            v-for="address in addresses"
            :key="address.id"
            :address="address"
            @setDefault="(id) => emit('setDefault', id)"
        />
    </div>
</template>

<script setup lang="ts">
import RoutingAddressCard from 'vcomponents/overview/tabs/routingAddresses/RoutingAddressCard.vue';
import type { RoutingAddress } from 'types/entities/einvoicing/routingAddress.type';

interface Props {
    addresses: RoutingAddress[];
}

defineProps<Props>();
const emit = defineEmits<{
    (event: 'setDefault', id: number): void;
}>();
</script>

<style lang="scss" scoped>
.routing-addresses-list {
    margin-top: var(--spacing-1);
}
</style>